import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'

import {ProductCardOrientation} from '../..'

import DiscountBadge from './Discount'
import OutOfStockBadge from './OutOfStock'
import UnavailableBadge from './Unavailable'
export interface BadgeProps {
  product: productListInformation
  unavailable: boolean
  isOutOfStock: boolean
  horizontallyReversed: boolean
  cardOrientation: ProductCardOrientation
}
function Badge(props: BadgeProps) {
  const {isOutOfStock, unavailable} = props

  if (isOutOfStock) return <OutOfStockBadge {...props} />
  if (unavailable) return <UnavailableBadge {...props} />
  return <DiscountBadge {...props} />
}

export default Badge
